import { Common } from '@stockbit/ui';
import { useDispatch, useSelector } from 'react-redux';
import { reportCategories } from '../constants';

import streamWidget, { selectors } from '../slice';

const { Select } = Common;

function SelectReportType() {
  const dispatch = useDispatch();

  const { filterParams } = useSelector(selectors);

  const handleChange = (key: string) => {
    dispatch(
      // @ts-ignore
      streamWidget.actions.setFilterParam({
        reporttype: key,
      }),
    );
  };

  const activeReportType = filterParams.reporttype || reportCategories[0].key;

  return (
    <Select
      value={activeReportType}
      onChange={handleChange}
      style={{ width: '100%' }}
    >
      {reportCategories.map((category) => (
        <Select.Option key={category.key} value={category.key}>
          {category.label}
        </Select.Option>
      ))}
    </Select>
  );
}

export default SelectReportType;
